import { Injectable, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { WidgetsEntity } from 'src/app/models/widget-entity.model';


@Injectable()
export class ComponentLoaderService {

  private componentNames = [
    "AssetPublisher",
    "DynamicContent",
    "Form",
    "Menu",
    "SmartTable",
    "Tabs",
    "TreeMenu",
    "WebContent"
  ];


  constructor() { }

  loadComponent(vcr: ViewContainerRef, component: Type<any>, props: WidgetsEntity | null): ComponentRef<any> {

    vcr.clear();

    const compRef: ComponentRef<any> = vcr.createComponent(component);

    if (props) {
      if (props && props.type && this.componentNames.includes(props.type)) { // Carico il widget
        Object.assign(compRef.instance, { ...props });
      } else { // Passo eventuali dati al widget
        compRef.instance.data = props;
      }
    }

    return compRef;

  }

}
